module.exports = __webpack_public_path__ + "static/media/6.da5c7695.jpg";